// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ic-0";